export default [{
	path: '/shop/shop',
	name: 'shop',
	component: () => import('@/projects/shop/shop'),
	meta: {
		title: '商家详情',
		index: 2,
		param: `id=商家ID`
	},

},
{
	path: '/shop/ershoujiaoyi',
	name: 'ershoujiaoyi',
	component: () => import('@/projects/shop/ershoujiaoyi'),
	meta: {
		title: '二手交易',
		index: 1,
	}
},
{
	path: '/shop/spdetail-pro',
	name: 'spdetail-pro',
	component: () => import('@/projects/shop/spdetail-pro'),
	meta: {
		title: '商品详情',
		index: 5,
		param: `id=商品ID`
	}
},
{
	path: '/shop/bannerDetail',
	name: 'bannerDetail',
	component: () => import('@/projects/shop/bannerDetail'),
	meta: {
		title: 'banner详情',
		index: 1,
	}
},

// {
// 	path: '/shop/spdetail-ershou',
// 	name: 'spdetail-ershou',
// 	component: () => import('@/projects/shop/spdetail-ershou'),
// 	meta: {
// 		title: '商品详情',
// 		index: 0,
// 	}
// },
// {
// 	path: '/shop/spdetail-car',
// 	name: 'spdetail-car',
// 	component: () => import('@/projects/shop/spdetail-car'),
// 	meta: {
// 		title: '车辆详情',
// 		index: 0,
// 	}
// },
// {
// 	path: '/shop/spdetail-ershoucar',
// 	name: 'spdetail-ershoucar',
// 	component: () => import('@/projects/shop/spdetail-ershoucar'),
// 	meta: {
// 		title: '车辆详情',
// 		index: 0,
// 	}
// },
// {
// 	path: '/shop/search',
// 	name: 'search',
// 	component: () => import('@/projects/shop/search'),
// 	meta: {
// 		title: '搜索',
// 		index: 0,
// 	}
// },
// {
// 	path: '/shop/search-result',
// 	name: 'search',
// 	component: () => import('@/projects/shop/search-result'),
// 	meta: {
// 		title: '搜索结果',
// 		index: 0,
// 	}
// },
{
	path: '/shop/carsearch',
	name: 'carsearch',
	component: () => import('@/projects/shop/carsearch'),
	meta: {
		title: '搜索',
		index: 2,
	}
},
{
	path: '/shop/carsearch-result',
	name: 'carsearch',
	component: () => import('@/projects/shop/carsearch-result'),
	meta: {
		title: '搜索结果',
		index: 1,
		param: `type=1  /1:搜索商品，2：搜索选车`
	}
},
{
	path: '/shop/classify',
	name: 'classify',
	component: () => import('@/projects/shop/classify'),
	meta: {
		title: '分类',
		index: 1,
		param: `id=一级分类ID /可选`
	}
},
{
	path: '/shop/classify-pro',
	name: 'classify',
	component: () => import('@/projects/shop/classify-pro'),
	meta: {
		title: '分类名称',
		index: 2,
	}
},
{
	path: '/shop/shoppingcar',
	name: 'shoppingcar',
	component: () => import('@/projects/shop/shoppingcar'),
	meta: {
		title: '购物车',
		index: 7,
	}
},
{
	path: '/shop/brand',
	name: 'brand',
	component: () => import('@/projects/shop/brand'),
	meta: {
		title: '品牌选车',
		index: 1,
	}
},
{
	path: '/shop/brand-detail',
	name: 'brand-detail',
	component: () => import('@/projects/shop/brand-detail'),
	meta: {
		title: '品牌详情',
		index: 2,
		param: "id=品牌ID"
	}
},
// {
// 	path: '/shop/brand-pro',
// 	name: 'brand-pro',
// 	component: () => import('@/projects/shop/brand-pro'),
// 	meta: {
// 		title: '品牌名称',
// 		index: 0,
// 	}
// },
{
	path: '/shop/sellcar',
	name: 'sellcar',
	component: () => import('@/projects/shop/sellcar'),
	meta: {
		title: '出售整车',
		index: 1,
	}
},
// {
// 	path: '/shop/sell-ershou',
// 	name: 'sell-ershou',
// 	component: () => import('@/projects/shop/sell-ershou'),
// 	meta: {
// 		title: '二手物品提交',
// 		index: 0,
// 	}
// },
{
	path: '/shop/sellcar-tjcg',
	name: 'sellcar-tjcg',
	component: () => import('@/projects/shop/sellcar-tjcg'),
	meta: {
		title: '提交成功',
		index: 4,
	}
},
{
	path: '/shop/contrast',
	name: 'contrast',
	component: () => import('@/projects/shop/contrast'),
	meta: {
		title: '加入对比',
		index: 6,
	}
},
// {
// 	path: '/shop/contrast-brand',
// 	name: 'contrast-brand',
// 	component: () => import('@/projects/shop/contrast-brand'),
// 	meta: {
// 		title: '选择品牌',
// 		index: 0,
// 	}
// },
// {
// 	path: '/shop/contrast-car',
// 	name: 'contrast-car',
// 	component: () => import('@/projects/shop/contrast-car'),
// 	meta: {
// 		title: '品牌名称',
// 		index: 0,
// 	}
// },
{
	path: '/shop/contrast-carlist',
	name: 'contrast-carlist',
	component: () => import('@/projects/shop/contrast-carlist'),
	meta: {
		title: '自行车Sku列表',
		index: 3,
		param: "id=商品ID"
	}
},
{
	path: '/shop/contrast-data',
	name: 'contrast-data',
	component: () => import('@/projects/shop/contrast-data'),
	meta: {
		title: '对比数据',
		index: 7,
	}
},
{
	path: '/shop/assembling-bicycles',
	name: 'contrast-data',
	component: () => import('@/projects/shop/assembling-bicycles'),
	meta: {
		title: '组装车辆',
		index: 7,
	}
},
{
	path: '/shop/carModel',
	name: 'carModel',
	component: () => import('@/projects/shop/carModel'),
	meta: {
		title: '对比数据',
		index: 7,
	}
},

	// {
	// 	path: '/shop/contrast-bj',
	// 	name: 'contrast-bj',
	// 	component: () => import('@/projects/shop/contrast-bj'),
	// 	meta: {
	// 		title: '加入对比',
	// 		index: 0,
	// 	}
	// }
]


// WEBPACK FOOTER //
// ./src/projects/shop/index.js